<template>
  <b-dropdown
    ref="dropdown"
    :class="['dropdown-custom', 'action-item', { 'active': isActive }]"
    right
  >
    <template #button-content>
      <i class="fas fa-filter icon-filter"/>
      {{ $t('message.filter') }}
    </template>
    <b-dropdown-group>
      <div class="container-filter">
        <template v-if="filterHeader == null ? true : filterHeader" >
          <li class="filter-header">
            <button
              :class="['btn', buttonDateTypeClass[FILTER_DATE_TYPE.DAY]]"
              @click="handleSelectDateType(FILTER_DATE_TYPE.DAY)"
            >
              {{ $t('button.day') }}
            </button>
            <!-- <button
              :class="['btn', buttonDateTypeClass[FILTER_DATE_TYPE.WEEK]]"
              @click="handleSelectDateType(FILTER_DATE_TYPE.WEEK)"
            >
              {{ $t('button.week') }}
            </button> -->
            <button
              :class="['btn', buttonDateTypeClass[FILTER_DATE_TYPE.MONTH]]"
              @click="handleSelectDateType(FILTER_DATE_TYPE.MONTH)"
            >
              {{ $t('button.month') }}
            </button>
            <!-- <button
              :class="['btn', buttonDateTypeClass[FILTER_DATE_TYPE.QUARTER]]"
              @click="handleSelectDateType(FILTER_DATE_TYPE.QUARTER)"
            >
              {{ $t('button.quarter') }}
            </button> -->
            <button
              :class="['btn', buttonDateTypeClass[FILTER_DATE_TYPE.YEAR]]"
              @click="handleSelectDateType(FILTER_DATE_TYPE.YEAR)"
            >
              {{ $t('button.year') }}
            </button>
          </li>
          <b-dropdown-divider/>
        </template>
        <li class="filter-body">
          <BaseDateRange
            v-model="form.dateRange"
          />
          <slot name="add"/>
        </li>
        <b-dropdown-divider/>
        <li class="filter-footer">
          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <button
                class="btn no-bg text-underline btn-set-to-default"
                @click="handleSetDefault">
                {{ $t('button.settodefault') }}
              </button>
            </div>
            <div class="col-8 d-flex align-items-center justify-content-end">
              <button
                class="btn btn-light"
                @click="handleCancel">
                {{ $t('button.cancel') }}
              </button>
              <button
                class="btn btn-web ml-2"
                @click="handleApply">
                {{ $t('button.apply') }}
              </button>
            </div>
          </div>
        </li>
      </div>
    </b-dropdown-group>
  </b-dropdown>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { FILTER_DATE_TYPE } from '../../helpers/enum'

export default {
  name: 'BaseDropdownFilterDateRange',

  props: ['type', 'range', 'active', 'filterHeader'],

  data () {
    return {
      FILTER_DATE_TYPE,
      form: {
        dateType: FILTER_DATE_TYPE.DAY,
        dateRange: {
          start: new Date(),
          end: new Date(),
        },
      },
      formOriginal: null,
      isShown: false,
      isApplied: false,
    }
  },

  computed: {
    ...mapGetters({
      dateFormat: 'getDateFormat',
    }),
    buttonDateTypeClass () {
      return {
        [FILTER_DATE_TYPE.DAY]: this.form.dateType === FILTER_DATE_TYPE.DAY ? 'btn-primary' : 'btn-light',
        [FILTER_DATE_TYPE.WEEK]: this.form.dateType === FILTER_DATE_TYPE.WEEK ? 'btn-primary' : 'btn-light',
        [FILTER_DATE_TYPE.MONTH]: this.form.dateType === FILTER_DATE_TYPE.MONTH ? 'btn-primary' : 'btn-light',
        [FILTER_DATE_TYPE.QUARTER]: this.form.dateType === FILTER_DATE_TYPE.QUARTER ? 'btn-primary' : 'btn-light',
        [FILTER_DATE_TYPE.YEAR]: this.form.dateType === FILTER_DATE_TYPE.YEAR ? 'btn-primary' : 'btn-light',
      }
    },
    isEqual () {
      const a = JSON.stringify(this.form)
      const b = JSON.stringify(this.formOriginal)
      return a === b
    },
    isActive () {
      if (this.isApplied || this.active) {
        return true
      }
      return !this.isEqual && !this.isShown
    },
  },

  created () {
    if (this.type) this.form.dateType = this.type
    if (this.range) this.form.dateRange = this.range
    this.formOriginal = _.cloneDeep(this.form)
  },

  mounted () {
    this.$root.$on('bv::dropdown::show', this.handleShow)
    this.$root.$on('bv::dropdown::hide', this.handleHide)
  },

  destroyed () {
    this.$root.$off('bv::dropdown::show', this.handleShow)
    this.$root.$off('bv::dropdown::hide', this.handleHide)
  },

  methods: {
    handleSelectDateType (dateType = '') {
      this.form.dateType = dateType
    },
    handleCancel () {
      this.form.dateType = this.type
      this.form.dateRange = this.range
      this.hide()
      this.$emit('onCancel')
    },
    handleSetDefault () {
      this.form = _.cloneDeep(this.formOriginal)
      this.$emit('onSetDefault')
    },
    handleApply () {
      if (!this.isEqual) {
        this.isApplied = true
      }
      this.hide()
      this.$emit('onSubmit', {
        type: this.form.dateType,
        start: this.form.dateRange.start,
        end: this.form.dateRange.end,
      })
    },
    hide () {
      this.$refs.dropdown.hide(true)
    },
    handleShow (bvEvent) {
      this.isShown = true
    },
    handleHide (bvEvent) {
      this.isShown = false
    },
  },
}
</script>

<style scoped>
.dropdown-custom /deep/ .dropdown-menu {
  padding: 0;
}

.dropdown-custom /deep/ .dropdown-toggle,
.dropdown-custom.show /deep/ .dropdown-toggle {
  background: none;
  color: #6c757d;
  box-shadow: none;
}

.dropdown-custom.active /deep/ .icon-filter {
  position: relative;
}

.dropdown-custom.active /deep/ .icon-filter::after {
  position: absolute;
  content: '';
  top: -3px;
  right: -3px;
  width: 8px;
  height: 8px;
  background-color: var(--link-color);
  border-radius: 50%;
}

.container-filter {
  min-width: 475px;
}

/* header */
.filter-header {
  display: flex;
  padding: 16px 0 8px 0;
}

.filter-header button {
  margin: 0 16px 0 16px;
  flex: 1;
}

/* body */
.filter-body {
  padding: 4px 16px 9px 16px;
}

.filter-body .c-pane-container {
  width: 100%;
  background: none !important;
  border: none !important;
}

/* footer */
.filter-footer {
  padding: 5px 16px 16px 16px;
}

.btn-primary {
  color: #fff;
  box-shadow: none;
}

.btn-set-to-default {
  padding: 0;
  color: #9B9A9A;
}

.btn-light {
  background: #F2F4F5;
}

button {
  padding: .375rem .75rem;
}

@media (max-width: 575.98px) {
  .container-filter {
    min-width: 350px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseDropdownFilterDateRange.vue